module.exports = __webpack_public_path__ + "7520c2281d676fd483778b939e8aff35.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/map_epidemic.png
 ** module id = 1067
 ** module chunks = 0
 **/